////////////////ShopCustomer.js

import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'

export const ShopCustomerRequest = {

    GetShopCustomer(func, ID) {
        $AjaxJson($UrlApipath + "Order/GetShopCustomer", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddShopCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Order/AddShopCustomer", obj, function (d) {
            func(d)
        })
    },
    GetShopName(func, obj) {
        $AjaxJson($UrlApipath + "Order/GetShopName", obj, function (d) {
            func(d)
        })
    },
    UpdateShopCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Order/UpdateShopCustomer", obj, function (d) {
            func(d)
        })
    },
    SearchShopCustomer(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchShopCustomer", obj, function (d) {
            func(d)
        })
  },
  Get2157AccessStore(func, obj) {
    $AjaxJson($UrlApipath + "Order/Get2157AccessStore", obj, function (d) {
        func(d)
    })
},
  SearchShopCustomerBySearch(func, obj) {
    $AjaxJson($UrlApipath + "Order/SearchShopCustomerBySearch", obj, function (d) {
        func(d)
    })
},
    SearchShopCustomerList(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchShopCustomerList", obj, function (d) {
            func(d)
        })
    },

    SetShopCustomerDedaultChannel(func, ID, DedaultChannel) {
        $AjaxJson($UrlApipath + "Order/SetShopCustomerDedaultChannel", { ID: ID, DedaultChannel: DedaultChannel }, function (d) {
            func(d)
        })
    },
    SetShopCustomerIsEnable(func, ID, IsEnable) {
        $AjaxJson($UrlApipath + "Order/SetShopCustomerIsEnable", { ID: ID, IsEnable: IsEnable }, function (d) {
            func(d)
        })
    },
    SetShopCustomerIsAutoGet(func, ID, IsAutoGet) {
        $AjaxJson($UrlApipath + "Order/SetShopCustomerIsAutoGet", { ID: ID, IsAutoGet: IsAutoGet }, function (d) {
            func(d)
        })
    },

    GetPlatForm(func, ID) {
        $AjaxJson($UrlApipath + "Order/GetPlatForm", { ID: ID }, function (d) {
            func(d)
        })
    },

    SearchPlatForm(func, obj) {
        $AjaxJson($UrlApipath + "Order/SearchPlatForm", obj, function (d) {
            func(d)
        })
    },

    GetShopCustomerProduct(func, ID) {
        $AjaxJson($UrlApipath + "Order/GetShopCustomerProduct", { ID: ID }, function (d) {
            func(d)
        })
    },
    GetShoppifyShopInfo(func, ID) {
        $AjaxJson($UrlApipath + "Order/GetShoppifyShopInfo", { ID: ID } , function (d) {
            func(d)
        })
    },



}




// WEBPACK FOOTER //
// ./src/request/ShopCustomer.js